<template>
    <div>
        <Row>
        <i-col span="22">
    <Form ref="formInline" label-position="right" :label-width="60" :model="formInline"  inline>
        <FormItem prop="user" label="关键字">
            <i-input type="text" v-model="formInline.keywords" placeholder="关键字"></i-input>
        </FormItem>
         <FormItem>
            <Button type="primary" @click="mockTableData" title="adminsearch">查询</Button>
        </FormItem>
         </Form>
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add" v-if="privilegesbtn('/admin/create')">新增</Button>  
        </i-col>
    </Row>
       
   
        <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :total="total" :current="page" @on-change="changePage" :page-size="pagesize" show-total></Page>
            </div>
        </div>
    </div>
</template>
<script>
import { lockadmin, adminlist, deleteadmin } from "../../api/adminapi";
import { mapState } from "vuex";
import privilegesbtn from '../../constant/privilegesbtn.js'
import openpage from '../../constant/openpage.js'
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte:privilegesbtn('/admin/update'),
      islock:privilegesbtn('/admin/lock'),
      isdelete:privilegesbtn('/admin/delete'),
      islog:privilegesbtn('/admin/log'),
      formInline: {
        keywords: ""
      },
      tableColumns: [
        {
          title: "用户名",
          key: "username",
          align: "center",
          width: 100,
          fixed: "left"
        },
        {
          title: "真实姓名",
          key: "realname",
      
          align: "center"
        },

        {
          title: "email",
          align: "center",
     
          key: "email"
        },
        {
          title: "手机号码",
          align: "center",
      
          key: "mobile"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createtime",
        
        },
        {
          title: "角色",
          align: "center",
        
          key: "role"
        },
        {
          title: "上次登陆时间",
          align: "center",
          key: "logintime",
       
        },
        {
          title: "锁定状态",
          key: "action",
          align: "center",
       
          render: (h, params) => {
            var islock = params.row.islock == 0 ? "未锁定" : "锁定";
            var _this = this;
            return h(
              "i-switch",
              {
                props: {
                  value: params.row.islock === 1,
                  size: "large",
                  disabled:(!this.islock)
                },
                on: {
                  "on-change": value => {
                    _this.adminlock(params.row);
                  }
                }
              },
              [
                h("span", {
                  slot: "open",
                  domProps: {
                    innerHTML: "锁定"
                  }
                }),
                h("span", {
                  slot: "close",
                  domProps: {
                    innerHTML: "未锁定"
                  }
                })
              ]
            );
          }
        },
        {
          title: "超级管理员",
          key: "issupper",
          align: "center",
          width: 100,
          render: (h, params) => {
            var issupper = params.row.issupper == 0 ? "不是" : "是";
            return h("span", issupper);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          fixed: "right",
          render: (h, params) => {

            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled:(!this.isupdte)
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled:(!this.isdelete)
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.adminlog(params.row.id);
                    }
                  }
                },
                "操作日志"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled:(!this.islog)
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  computed: mapState({
    privilegescheck: state => state.privilegescheck
  }),
  methods: {
    privilegesbtn:privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize,
        keywords: this.formInline.keywords
      };
      this.$Loading.start();
      adminlist(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.data.total;
        this.tableData = Data.data.data;
      });
    },
    adminlock(param) {
      let para = {
        id: param.id
      };
      this.$Loading.start();
      lockadmin(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
        } else {
          this.changePage(this.page);
          this.$Message.error(data.message);
        }
      });
    },
    show(param) {
      // if (param && param.id) {
      //   var info = {
      //   Id: "23",
      //   name:"编辑管理员",
      //   ComName: "Addminupdte",
      //   isShow: false,
      //   param: { id: param.id },
      //   refresh: true
      // };
      // this.$store.commit("addTab", info);
      this.$router.push({ path: "/adminupdte", query: { id: param.id } });
    },
    add() {
      // openpage("/adminadd",null)
    this.$router.push({ path: "/adminadd" });
    },
    adminlog(id) {
      this.$router.push({
        path: "/Adminlog",
        query: { id: id }
      });
    },
    remove(index) {
      let self = this;
      this.$Modal.confirm({
        title: "管理员列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: index };
          deleteadmin(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();

  }
};
</script>


// WEBPACK FOOTER //
// src/pages/admin/index.vue